import React, { useEffect, useRef, useState } from 'react';

const AboutPartners = () => {
  const partners = [
    { name: "Holy", image: "./assets/partners/holy-logo.png", white: true },
    { name: "Razer", image: "./assets/partners/razer-logo.png", white: true },
    { name: "Quersus", image: "./assets/partners/quersus-logo.png", white: true },
    { name: "Make-It-Shine", image: "./assets/partners/make-it-shine-logo.png", white: true },
    { name: "Free", image: "./assets/partners/free-logo.png", white: true },
    { name: "Logitech", image: "./assets/partners/logitech-logo.png", white: true },
  ];

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className="about-partners w-full" style={{ backgroundColor: 'rgb(10, 1, 1)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className=" partners-grid grid md:grid-cols-2 gap-12 items-center">
          <div className={`space-y-6 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
          }`}>
            <h2 className="text-4xl font-bold text-[#e0e0e0]">
              Ils nous font confiance
            </h2>
            <p className="text-lg text-[#e0e0e0]">
              Découvrez les partenaires qui nous accompagnent dans notre aventure e-sport 
              et qui contribuent à notre succès. 
              <br />Ensemble, nous construisons l'avenir du gaming compétitif.
            </p>
            <div className=" catch-phrase pt-4">
                <a className="about-btn" href="">Devenir Partenaire</a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 md:grid-cols-2">
            {partners.map((partner, index) => (
              <div
                key={partner.name}
                className={`transform transition-all duration-1000 delay-${index * 150} 
                  ${isVisible 
                    ? 'opacity-100 translate-y-0' 
                    : 'opacity-0 translate-y-8'
                  }
                  group cursor-pointer
                `}
              >
                <div className="bg-neutral-900 p-4 rounded-xl border border-neutral-800 partner-card 
                  transition-all duration-300 group-hover:border-white/20 h-full flex flex-col justify-center">
                  <img
                    src={partner.image}
                    alt={partner.name}
                    className={`w-20 h-20 object-contain mx-auto mb-3 
                      transition-transform duration-300 group-hover:scale-110
                      ${partner.white ? 'brightness-0 invert' : ''}
                    `}
                    style={{
                      filter: partner.white ? 'brightness(0) invert(1)' : 'none'
                    }}
                  />
                  <h3 className="text-base font-semibold text-white text-center">
                    {partner.name}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPartners;